import { InstitutionProductTypeModelDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../../shared';

export class InstitutionProduct extends DomainEntity<InstitutionProductTypeModelDto> {
    public static from(dto: InstitutionProductTypeModelDto): InstitutionProduct {
        return new InstitutionProduct(dto);
    }

    public createDefault(): this {
        throw new Error('createDefault not implemented');
    }

    public get id() {
        return this.dto.id;
    }

    public get productTypeId() {
        return this.dto.productTypeId;
    }

    public get name() {
        return this.dto.name;
    }

    public get description() {
        return this.dto.description;
    }

    public get status() {
        return this.dto.status;
    }
}
